export default "__VITE_ASSET__b78a400d__"